import type { CSSProperties } from 'react'
import { RAIL_OVERLAY_OFFSET_PX } from '@/shared/theme/railSlot'
import type { RailHoverGeometry } from '@/shared/components/RailHoverBubble/useRailHoverLabel'

const FLYOUT_EDGE_PX = 6

export interface FlyoutPlacement {
  card: CSSProperties
  arrow: CSSProperties
}

const getFlyoutPlacement = ({ anchor, card }: RailHoverGeometry, viewportHeight: number): FlyoutPlacement => {
  const left = card.right + RAIL_OVERLAY_OFFSET_PX
  const anchorMiddle = anchor.height / 2 + FLYOUT_EDGE_PX

  if (anchor.top + anchor.height / 2 <= viewportHeight / 2) {
    return {
      card: { left, top: anchor.top - FLYOUT_EDGE_PX },
      arrow: { top: anchorMiddle, transform: 'translateY(-50%) rotate(45deg)' },
    }
  }

  return {
    card: { left, bottom: viewportHeight - anchor.bottom - FLYOUT_EDGE_PX },
    arrow: { bottom: anchorMiddle, transform: 'translateY(50%) rotate(45deg)' },
  }
}

export default getFlyoutPlacement
